import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/components/base-component';

@Component({
  selector: 'app-signature-footer',
  templateUrl: './signature-footer.component.html',
  styleUrls: ['./signature-footer.component.scss']
})
export class SignatureFooterComponent extends BaseComponent {

  constructor() {super();}
}
